import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@99designs/common/components/Icon';
import { IconButton } from '@99designs/common/components/IconButton';
import ToggleButton from './toggle-button';
import superagent from 'superagent';
import { get as getCookie } from 'cookies-js';

const genericXhrHeadersWithCsrf = () => {
    const token = getCookie('_99csrf') || 'fake-token';
    return {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': token,
    };
};

const putRequest = (url) => {
    return superagent.put(url).set(genericXhrHeadersWithCsrf());
};

const deleteRequest = (url) => {
    return superagent.delete(url).set(genericXhrHeadersWithCsrf());
};

const toggleRequest = (toggleState, url) => {
    if (toggleState) {
        return putRequest(url);
    }
    return deleteRequest(url);
};

const FavoriteButton = ({ isFavorite, favoriteUrl }) => (
    <ToggleButton
        isToggled={isFavorite}
        xhrUrl={favoriteUrl}
        toggleRequest={toggleRequest}
        render={({ isToggled, onToggle }) => (
            <IconButton
                variations={['soft-toggle', classNames({ selected: isToggled })]}
                onClick={onToggle}
            >
                <Icon type={'heart-1'} />
            </IconButton>
        )}
    />
);

FavoriteButton.propTypes = {
    isFavorite: PropTypes.bool.isRequired,
    favoriteUrl: PropTypes.string.isRequired,
};

export default FavoriteButton;



// WEBPACK FOOTER //
// ./src/web/js/browse/components/favorite-button.jsx